import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { QuickBriefService } from '../../services/quick-brief.service';

@Component({
  selector: 'qb-summary-panel',
  templateUrl: './summary-panel.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'h-full min-h-0 flex-col overflow-y-auto bg-gradient-to-br from-brand-studio to-fuchsia-500 text-white dark:from-brand-deep-purple dark:to-brand-studio-dark' },
})
export class QbSummaryPanel {
  readonly brief = inject(QuickBriefService);
}
